module.exports = __webpack_public_path__ + "94db8929d011bd2be605fcf9346f88c6.pdf";